<template>
    <v-container fluid class="pa-0">
        <!--tabs-->
        <v-divider></v-divider>
        <v-tabs v-model="tab" height="35" 
            background-color="primary" fixed-tabs hide-slider dark>
            <v-tab :to="link(item)" ripple class="text-capitalize" 
                exact-active-class v-for="item in itemsTab" 
                :key="item">
                {{ item }}
            </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
            <v-tab-item value="/admin/promo/profile">
                <profile />
            </v-tab-item>
            <v-tab-item value="/admin/promo/institutes">
                <institutes />
            </v-tab-item>
            <v-tab-item value="/admin/promo/users">
                <users />
            </v-tab-item>
        </v-tabs-items>
    </v-container>
</template>

<script>
import Profile from '../admin/promo/Profile.vue';
import Institutes from './promo/Institutes.vue';
import Users from '../admin/promo/Users.vue';

export default {
    name: 'Promo',
    data() {
        return {
            itemsTab: ['Profile', 'Institutes', 'Users'],
            tab: 0,
            valid: false,
            error: '',
            rules: {
                required: value => !!value || 'required field',
            },
            set: { item: 'standart', value: 2 },
        }
    },
    computed: {
        institutes() {
            return this.$store.getters.institutes;
        },
        loading() {
            return this.$store.getters.loading;
        },
        user() {
            return this.$store.getters.user;
        },
        games() {
            return this.$store.getters.games;
        },
        sets() {
            const fixed_arr = [
                { item: 'simple', value: 1 },
                { item: 'standart', value: 2 },
                { item: 'advanced', value: 3 }
            ]

            const custom_arr = this.games.filter(game => game.id > 3)
            if (custom_arr.length > 0) {
                custom_arr.map(item => {
                    fixed_arr.push({
                        item: `${item.category}_${item.id}`,
                        value: item.id
                    })
                })
            }

            return fixed_arr;
        },
        institutesRout() {
            return /\/promo\/institutes/.test(this.$route.path)
        },
        usersRout() {
            return /\/promo\/users/.test(this.$route.path)
        },
    },
    watch: {
        loggedIn() {
            if (!this.loggedIn) {
                this.$router.push('/home');
            }
        }
    },
    methods: {
        dateToString(date) {
            return date.toLocaleString('en-GB', { timeZone: 'UTC' }).substr(0, 10);
        },
        link(name) {
            const arr = name.split(' ');
            if (arr.length > 1) {
                return `/admin/promo/${arr[1].toLowerCase()}`
            }
            return `/admin/promo/${name.toLowerCase()}`
        },
    },
    components: {
        Profile, Institutes, Users,
    },
    async mounted() {
        if (!this.games.length) {
            try {
                await this.$store.dispatch('fetchAllGames');
            }
            catch (error) {
                console.log(error.message)
            }
        }
    }
}
</script>